import { client, urlFor, getSanityEditLink } from "./sanity-client";
import initScrollAnimations from "./animations";

document.addEventListener("DOMContentLoaded", async () => {
  const aboutContent = document.querySelector(".why-coriolis-v3");
  if (!aboutContent) return;

  try {
    const query = `*[_type == "ourRoots"][0]{
      ...,
      showHero,
      showPrinciples,
      showBanner,
      features[]{
        ...,
        _key
      }
    }`;
    const data = await client.fetch(query);

    if (!data) {
      console.error("About data not found");
      return;
    }

    renderWhyCoriolis(data);
    
    // Re-initialize animations after content injection
    initScrollAnimations();

  } catch (error) {
    console.error("Error fetching about data:", error);
  }
});

function renderWhyCoriolis(data) {
  const docId = data._id;

  // 1. Hero Section
  const heroSection = document.querySelector(".hero-section");
  if (heroSection) {
    if (data.showHero === false) {
      heroSection.classList.add("d-none");
    } else {
      heroSection.classList.remove("d-none");
      
      const headlineEl = document.getElementById("hero-headline");
      const subtextEl = document.getElementById("hero-subtext");

      if (headlineEl && data.rootsTitle) {
        let headline = data.rootsTitle;
        if (headline.includes("principles.")) {
          headline = headline.replace("principles.", "<span>principles.</span>");
        }
        headlineEl.innerHTML = headline;
        
        injectEditLink(headlineEl, docId, 'rootsTitle', 'Edit Hero Headline');
      }

      if (subtextEl && data.rootsDescription) {
        subtextEl.textContent = data.rootsDescription;
      }
    }
  }

  // 2. Principles Grid
  const principlesSection = document.querySelector(".principles-grid") || document.querySelector(".section-v3.pt-0");
  if (principlesSection) {
    if (data.showPrinciples === false) {
      principlesSection.classList.add("d-none");
    } else {
      principlesSection.classList.remove("d-none");
      
      const topRowEl = document.getElementById("principles-top-row");
      const bottomRowEl = document.getElementById("principles-bottom-row");

      if (topRowEl && bottomRowEl && data.features) {
        const topFeatures = data.features.slice(0, 4);
        const bottomFeatures = data.features.slice(4, 7);

        topRowEl.innerHTML = topFeatures.map((f, i) => createPrincipleCard(f, docId, "col-lg-3", i * 100)).join('');
        bottomRowEl.innerHTML = bottomFeatures.map((f, i) => createPrincipleCard(f, docId, "col-lg-4", i * 100)).join('');
      }
    }
  }

  // 3. Bottom Banner
  const bannerSection = document.querySelector(".banner-v3")?.closest(".section-v3");
  if (bannerSection) {
    if (data.showBanner === false) {
      bannerSection.classList.add("d-none");
    } else {
      bannerSection.classList.remove("d-none");
      
      const bannerTextEl = document.getElementById("footer-banner-text");
      if (bannerTextEl && data.footerBanner) {
        let bannerText = data.footerBanner;
        if (bannerText.includes("every day.")) {
          bannerText = bannerText.replace("every day.", "<span>every day.</span>");
        }
        bannerTextEl.innerHTML = bannerText;
        
        injectEditLink(bannerTextEl, docId, 'footerBanner', 'Edit Banner Text');
      }
    }
  }
}

function createPrincipleCard(feature, docId, lgColClass, delay) {
  const icon = feature.iconName || 'layers';
  
  return `
    <div class="col-12 col-md-6 ${lgColClass}" data-animate="fade-up" data-delay="${delay}">
      <div class="principle-card position-relative">
        ${docId && feature._key ? getSanityEditLink(docId, 'ourRoots', `features[_key=="${feature._key}"]`, 'Edit Principle') : ''}
        <div class="principle-card-header">
          <span class="principle-icon"><i class="fe fe-${icon}"></i></span>
          <h4>${feature.title || ''}</h4>
        </div>
        <p>${feature.description || ''}</p>
      </div>
    </div>
  `;
}

function injectEditLink(el, docId, fieldName, label) {
  if (!el || !docId) return;
  const link = getSanityEditLink(docId, 'ourRoots', fieldName, label);
  if (link) {
    el.parentElement.classList.add('position-relative');
    el.insertAdjacentHTML('afterbegin', link);
  }
}
